import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('CASHBOX_REGISTER', [
    'MOVEMENTS',
    'OPENING_HISTORY',
    'OPENING_HISTORY_FILTER',
    'OPENING_HISTORY_BOARD',
    'SALES_TABLE'
])
